import { api, setConfig, UPDATE_IMAGE_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType, mapToFormData } from '../../../common';

export const updateUserImage = (data: PropertyType): Promise<string | void> =>
	api.post('/profile/profile-image', mapToFormData(mapEntityToApi(data)), setConfig(data)).then(() => {
		return UPDATE_IMAGE_MESSAGE;
	});
